import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from './../store'

import SignIn from "@/views/teacher/SignIn.vue"
import SheetList from "@/views/teacher/SheetList.vue"
import CurriculumList from "@/views/teacher/CurriculumList.vue"
import CurriculumUpload from "@/views/teacher/CurriculumUpload.vue"
import EventList from "@/views/teacher/EventList.vue"
import EventUpload from "@/views/teacher/EventUpload.vue"
import RoomList from "@/views/teacher/RoomList.vue"
import RoomUpload from "@/views/teacher/RoomUpload.vue"
import CourseList from "@/views/teacher/CourseList.vue"
import CourseUpload from "@/views/teacher/CourseUpload.vue"
import ClassifcationList from "@/views/teacher/ClassifcationList.vue"
import ClassifcationUpload from "@/views/teacher/ClassifcationUpload.vue"
import CramStudentList from "@/views/teacher/CramStudentList.vue"
import CramStudentUpload from "@/views/teacher/CramStudentUpload.vue"
import BaseSheetList from "@/views/teacher/BaseSheetList.vue"
import BaseSheetEdit from "@/views/teacher/BaseSheetEdit.vue"
import BaseSheetUpload from "@/views/teacher/BaseSheetUpload.vue"
import QrBaseSheetUpload from "@/views/teacher/QrBaseSheetUpload.vue"
import FieldEdit from "@/views/teacher/FieldEdit.vue"
import CorrectImageUpload from "@/views/teacher/CorrectImageUpload.vue"
import PositionEdit from "@/views/teacher/PositionEdit.vue"
import ScorePositionEdit from "@/views/teacher/ScorePositionEdit.vue"
import QuestionPdfUpload from "@/views/teacher/QuestionPdfUpload.vue"
import ExplanationPdfUpload from "@/views/teacher/ExplanationPdfUpload.vue"
import DaimonUpload from "@/views/teacher/DaimonUpload.vue"
import WebupList from "@/views/teacher/WebupList.vue"
import WebupDetail from "@/views/teacher/WebupDetail.vue"
import SheetUpload from "@/views/teacher/SheetUpload.vue"
import SaitenList from "@/views/teacher/SaitenList.vue"
import SaitenInput from "@/views/teacher/SaitenInput.vue"
import SaitenInputQuestionPdf from "@/views/teacher/SaitenInputQuestionPdf.vue"
import SaitenInputExplanationPdf from "@/views/teacher/SaitenInputExplanationPdf.vue"
import IkkatsuFieldUpload from "@/views/teacher/IkkatsuFieldUpload.vue"
import IkkatsuCorrectImageUpload from "@/views/teacher/IkkatsuCorrectImageUpload.vue"
import IkkatsuExplanationUpload from "@/views/teacher/IkkatsuExplanationUpload.vue"
import IkkatsuQuestionUpload from "@/views/teacher/IkkatsuQuestionUpload.vue"
import IkkatsuDaimonUpload from "@/views/teacher/IkkatsuDaimonUpload.vue"

import SumupList from "@/views/teacher/SumupList.vue";
import TeacherList from "@/views/teacher/TeacherList.vue";
import TeacherCreate from "@/views/teacher/TeacherCreate.vue";
import TeacherExcelUpload from "@/views/teacher/TeacherExcelUpload.vue";

import UserEdit from "@/views/teacher/UserEdit.vue";

import SchoolList from "@/views/teacher/SchoolList.vue";
import SchoolEdit from "@/views/teacher/SchoolEdit.vue";

import StudentList from "@/views/teacher/StudentList.vue";
import SumupResultDownload from "@/views/teacher/SumupResultDownload.vue"
import StudentSheetList from "@/views/teacher/StudentSheetList.vue";
import ResultRankDetail from "@/views/student/ResultRankDetail.vue";
import StudentSiteSheetList from "@/views/student/SheetList.vue";

import DummyBaseSheetEdit from "@/views/teacher/DummyBaseSheetEdit.vue"

import ScoreChangeLogList from "@/views/teacher/ScoreChangeLogList.vue"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { path: "/", name: "SignIn", component: SignIn },
  { path: "/teacher_site/sheet_list", name: "SheetList", component: SheetList },
  { path: "/teacher_site/room_list", name: "RoomList", component: RoomList },
  { path: "/teacher_site/room_upload", name: "RoomUpload", component: RoomUpload },
  { path: "/teacher_site/curriculum_list", name: "CurriculumList", component: CurriculumList },
  { path: "/teacher_site/curriculum_upload", name: "CurriculumUpload", component: CurriculumUpload },
  { path: "/teacher_site/event_list", name: "EventList", component: EventList },
  { path: "/teacher_site/event_upload", name: "EventUpload", component: EventUpload },
  { path: "/teacher_site/course_list", name: "CourseList", component: CourseList },
  { path: "/teacher_site/course_upload", name: "CourseUpload", component: CourseUpload },
  { path: "/teacher_site/classifcation_list", name: "ClassifcationList", component: ClassifcationList },
  { path: "/teacher_site/classifcation_upload", name: "ClassifcationUpload", component: ClassifcationUpload },
  { path: "/teacher_site/cram_student_list", name: "CramStudentList", component: CramStudentList },
  { path: "/teacher_site/cram_student_upload", name: "CramStudentUpload", component: CramStudentUpload },
  { path: "/teacher_site/base_sheet_list", name: "BaseSheetList", component: BaseSheetList },
  { path: "/teacher_site/base_sheet_edit/:base_sheet_id", name: "BaseSheetEdit", component: BaseSheetEdit },
  { path: "/teacher_site/base_sheet_upload", name: "BaseSheetUpload", component: BaseSheetUpload },
  { path: "/teacher_site/qr_base_sheet_upload", name: "QrBaseSheetUpload", component: QrBaseSheetUpload },
  { path: "/teacher_site/field_edit/:base_sheet_id", name: "FieldEdit", component: FieldEdit },
  { path: "/teacher_site/correct_image_upload/:base_sheet_id", name: "CorrectImageUpload", component: CorrectImageUpload },
  { path: "/teacher_site/position_edit/:base_sheet_id", name: "PositionEdit", component: PositionEdit },
  { path: "/teacher_site/score_position_edit/:base_sheet_id", name: "ScorePositionEdit", component: ScorePositionEdit },
  { path: "/teacher_site/question_pdf_upload/:base_sheet_id", name: "QuestionPdfUpload", component: QuestionPdfUpload },
  { path: "/teacher_site/explanation_pdf_upload/:base_sheet_id", name: "ExplanationPdfUpload", component: ExplanationPdfUpload },
  { path: "/teacher_site/daimon_upload/:base_sheet_id", name: "DaimonUpload", component: DaimonUpload },
  { path: "/teacher_site/webup_list", name: "WebupList", component: WebupList }, 
  { path: "/teacher_site/webup_detail/:webup_history_id", name: "WebupDetail", component: WebupDetail }, 
  { path: "/teacher_site/sheet_upload/:sheet_id", name: "SheetUpload", component: SheetUpload }, 
  { path: "/teacher_site/saiten_list/:sheet_id", name: "SaitenList", component: SaitenList }, 
  { path: "/teacher_site/saiten_input/:sheet_id/:sheet_field_id", name: "SaitenInput", component: SaitenInput },
  { path: "/teacher_site/saiten_input_question_pdf/:base_sheet_id", name: "SaitenInputQuestionPdf", component: SaitenInputQuestionPdf },
  { path: "/teacher_site/saiten_input_explanation_pdf/:base_sheet_id", name: "SaitenInputExplanationPdf", component: SaitenInputExplanationPdf },
  { path: "/teacher_site/saiten_input/:sheet_id/:sheet_field_id", name: "SaitenInput", component: SaitenInput }, 
  { path: "/teacher_site/ikkatsu_field_upload", name: "IkkatsuFieldUpload", component: IkkatsuFieldUpload },
  { path: "/teacher_site/ikkatsu_correct_image_upload", name: "IkkatsuCorrectImageUpload", component: IkkatsuCorrectImageUpload },
  { path: "/teacher_site/ikkatsu_explanation_upload", name: "IkkatsuExplanationUpload", component: IkkatsuExplanationUpload },
  { path: "/teacher_site/ikkatsu_question_upload", name: "IkkatsuQuestionUpload", component: IkkatsuQuestionUpload },
  { path: "/teacher_site/ikkatsu_daimon_upload", name: "IkkatsuDaimonUpload", component: IkkatsuDaimonUpload },

  { path: "/teacher_site/sumup_list", name: "SumupList", component: SumupList },
  { path: "/teacher_site/teacher_list", name: "TeacherList", component: TeacherList},
  {
    path: "/teacher_site/teacher_create",
    name: "TeacherCreate",
    component: TeacherCreate,
    beforeEnter: (to, from, next) => {
      const queryRole = to.query?.["role"];
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || (queryRole == "admin" && currentUser.role != "admin")) {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },
  { path: "/teacher_site/teacher_excel_upload", name: "TeacherExcelUpload", component: TeacherExcelUpload},

  { path: "/teacher_site/user_edit", name: "UserEdit", component: UserEdit },

  {
    path: "/teacher_site/school_list",
    name: "SchoolList",
    component: SchoolList,
    beforeEnter: (to, from, next) => {
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || currentUser.role != "admin") {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },
  {
    path: "/teacher_site/school_edit",
    name: "SchoolEdit",
    component: SchoolEdit,
    beforeEnter: (to, from, next) => {
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || currentUser.role != "admin") {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },

  { path: "/teacher_site/student_list", name: "StudentList", component: StudentList },
  { path: "/teacher_site/sumup_result_download", name: "SumupResultDownload", component: SumupResultDownload },
  { path: "/teacher_site/student_sheet_list", name: "StudentSiteSheetList", component: StudentSiteSheetList },
  { path: "/teacher_site/result_rank_detail/:sheet_id/:cram_student_id", name: "ResultRankDetail", component: ResultRankDetail },
  { path: "/student_site/result_rank_detail/:sheet_id/:cram_student_id", name: "ResultRankDetail", component: ResultRankDetail },
  { path: "/student_site/sheet_list", name: "StudentSiteSheetList", component: StudentSiteSheetList },

  { path: "/teacher_site/dummy_base_sheet_edit", name: "DummyBaseSheetEdit", component: DummyBaseSheetEdit },

  { path: "/teacher_site/score_change_log_list", name: "ScoreChangeLogList", component: ScoreChangeLogList },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
